import React, { useEffect, useState } from 'react';
import Footer from '../../shared/footer/Footer';
import LoginModal from '../../main/loginModal/LoginModal';
import Head from '../../Global/Head';
import Header from '../../Global/Header';
import img from '../../../images/blog1.jpg';
import { AiOutlineCalendar, AiOutlineShareAlt } from 'react-icons/ai';
import { HiOutlineLocationMarker } from 'react-icons/hi';
import { BsBookmark } from 'react-icons/bs';

export default function Blog1() {
  const accessToken = localStorage.getItem("@user");
  const [isVisible, setIsVisible] = useState(!!accessToken ? false : true);
  const [topPosition, setTopPosition] = useState(50);

  useEffect(() => {
    let interval;
    const totalTime = 1500;
    const steps = 800;
    const intervalTime = totalTime / steps;
    const increment = 1300 / steps;

    if (isVisible) {
      interval = setInterval(() => {
        setTopPosition((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            return 0;
          }
          return prev - increment;
        });
      }, intervalTime);
    }

    return () => clearInterval(interval);
  }, [isVisible]);

  const slideGoDown = () => {
    const totalTime = 1500; // Total animation time
    const steps = 800; // Number of steps
    const intervalTime = totalTime / steps; // Time per step
    const increment = 1300 / steps; // Position change per step

    let interval = setInterval(() => {
      setTopPosition((prev) => {
        if (prev >= 80) {
          clearInterval(interval); // Stop the interval
          setTimeout(() => setIsVisible(false), 0); // Change state after animation ends
          return 80; // Ensure it stops at the original position
        }
        return prev + increment; // Increment position to slide down
      });
    }, intervalTime);
  };

  const BlankModal = ({ isVisible, setIsVisible }) => {
    return (
      <div
        className={`fixed inset-0 z-[1000]  transition-opacity duration-300 ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 login-slide-up  bg-black"
          onClick={() => setIsVisible(false)}
        ></div>
        <div className="relative w-full h-screen">
          <div
            style={{ top: `${topPosition}%` }} // Dynamic top position
            className="absolute w-full h-screen transition-none"
          >
            <LoginModal setIsVisible={setIsVisible} slideGoDOwn={slideGoDown} />
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="min-h-screen ">
      <BlankModal setIsVisible={setIsVisible} isVisible={isVisible} />
      <Head />

      <Header />
      <div className="max-w-7xl mx-auto p-6">
        <h1 className="text-4xl font-bold mt-4">Why Hightable is More Than Just a Platform?</h1>
        <div className="mt-4 flex items-start justify-between">
          <div className="flex items-center gap-4 text-sm text-gray-600">
           
            <div className="flex items-center gap-2">
              <span className="inline-block bg-black text-white px-2 py-0.5 rounded">HighTable</span>
            </div>
          </div>
         
        </div>

        <div className="mt-6 rounded-lg overflow-hidden">
          <img src={img} alt="Why Hightable" className="w-full h-64 sm:h-96 object-cover" />
        </div>

        <div className="prose max-w-none mt-6">
          <p>
            In a world overflowing with digital spaces, it’s easy to feel “connected” without ever
            truly belonging. Hightable is different — it’s not just another app or networking
            platform. It’s a thoughtfully designed space to help you find your people, build
            meaningful connections, and grow personally and professionally.
          </p>

          <h2>Connection without the noise</h2>
          <p>
            Many platforms promise connection but deliver surface-level interactions. Hightable
            flips that script. Here, it’s not about the number of contacts or likes — it’s about
            quality conversations that actually matter. Whether you’re seeking friendship,
            mentorship, or shared experiences, Hightable helps you meet like-minded people in
            safe, welcoming spaces.
          </p>

          <h2>What makes Hightable unique</h2>
          <ul>
            <li><strong>Shared interests</strong> — Connect with people who resonate with your passions, goals, and values.</li>
            <li><strong>Safe & inclusive</strong> — Every interaction is built on safety, respect, and authenticity.</li>
            <li><strong>Flexible engagement</strong> — Participate at your own pace: join a conversation, share when ready, or observe.</li>
            <li><strong>Empowerment</strong> — Especially for women, Hightable offers spaces to share, learn, and support one another.</li>
          </ul>

          <h2>The power of belonging</h2>
          <p>
            Humans are wired for connection. Strong social bonds improve mental health,
            resilience, and overall well-being. Yet in busy, digital-first lives, finding your
            tribe can feel impossible. Hightable bridges that gap — it’s where strangers become
            allies, ideas spark collaboration, and everyday interactions turn into meaningful
            relationships.
          </p>

          <h2>How you benefit</h2>
          <ul>
            <li>Discover mentorship or guidance for personal and professional pursuits.</li>
            <li>Build friendships that extend beyond the app.</li>
            <li>Share experiences, insights, and support with like-minded people.</li>
            <li>Feel seen, heard, and understood in a safe environment.</li>
          </ul>

          <h2>Why join Hightable today</h2>
          <p>
            The difference between being “connected” and truly belonging is huge. Hightable
            isn’t about adding contacts to a list — it’s about creating relationships that matter.
            Join to find support, lift others, and grow together. By joining Hightable you’re
            investing in your network, your well-being, and your personal growth.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
